import { GetAuthUrlInteractor } from '../../auth/domain/interactors/get-auth-url.interactor';

export class GetMicrosoftAuthUrlInteractor implements GetAuthUrlInteractor {
  constructor(
    private readonly clientId: string,
    private readonly redirectUri: string,
    private readonly scopes: string[],
  ) {}

  // A change here
  public execute(state: string, pkceChallenge: string, forceConsent: boolean): string {
    // See: https://learn.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow
    const params = [
      `client_id=${this.clientId}`,
      `code_challenge_method=S256`,
      `code_challenge=${pkceChallenge}`,
      `redirect_uri=${encodeURIComponent(this.redirectUri)}`,
      `response_mode=query`,
      `response_type=code`,
      // This line was causing a problem -- It was prompting the "Need admin approval"
      // forceConsent ? `prompt=consent` : `prompt=select_account`,
      `prompt=select_account`,
      `scope=${encodeURIComponent(this.scopes.join(' '))}`,
      `state=${state}`,
    ].join('&');

    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params}`;
  }
}
